import { inputAnatomy as u } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as g, cssVar as p, defineStyle as h } from "@chakra-ui/styled-system";
import { getColor as o, mode as d } from "@chakra-ui/theme-tools";
const { definePartsStyle: a, defineMultiStyleConfig: m } = g(u.keys), l = p("input-height"), s = p("input-font-size"), b = p("input-padding"), c = p("input-border-radius"), x = a({
  addon: {
    height: l.reference,
    fontSize: s.reference,
    px: b.reference,
    borderRadius: c.reference
  },
  field: {
    width: "100%",
    height: l.reference,
    fontSize: s.reference,
    px: b.reference,
    borderRadius: c.reference,
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
}), t = {
  lg: h({
    [s.variable]: "fontSizes.lg",
    [b.variable]: "space.4",
    [c.variable]: "radii.md",
    [l.variable]: "sizes.12"
  }),
  md: h({
    [s.variable]: "fontSizes.md",
    [b.variable]: "space.4",
    [c.variable]: "radii.md",
    [l.variable]: "sizes.10"
  }),
  sm: h({
    [s.variable]: "fontSizes.sm",
    [b.variable]: "space.3",
    [c.variable]: "radii.sm",
    [l.variable]: "sizes.8"
  }),
  xs: h({
    [s.variable]: "fontSizes.xs",
    [b.variable]: "space.2",
    [c.variable]: "radii.sm",
    [l.variable]: "sizes.6"
  })
}, C = {
  lg: a({
    field: t.lg,
    group: t.lg
  }),
  md: a({
    field: t.md,
    group: t.md
  }),
  sm: a({
    field: t.sm,
    group: t.sm
  }),
  xs: a({
    field: t.xs,
    group: t.xs
  })
};
function f(r) {
  const { focusBorderColor: e, errorBorderColor: i } = r;
  return {
    focusBorderColor: e || d("indigo.500", "indigo.300")(r),
    errorBorderColor: i || d("red.500", "red.500")(r)
  };
}
const v = a((r) => {
  const { theme: e } = r, { focusBorderColor: i, errorBorderColor: n } = f(r);
  return {
    field: {
      border: "1px solid",
      borderColor: "gray.400",
      _dark: {
        borderColor: "whiteAlpha.400"
      },
      bg: "inherit",
      _hover: {
        borderColor: "gray.400",
        boxShadow: "0 0 0 1px ".concat(o(e, "gray.400")),
        _dark: {
          borderColor: "whiteAlpha.400",
          boxShadow: "0 0 0 1px ".concat(o(e, "whiteAlpha.400"))
        }
      },
      _readOnly: {
        color: "gray.500",
        bg: "coldGray.100",
        _dark: {
          bg: "whiteAlpha.200"
        },
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: o(e, n),
        boxShadow: "0 0 0 1px ".concat(o(e, n))
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: o(e, i),
        boxShadow: "0 0 0 1px ".concat(o(e, i)),
        _readOnly: {
          borderColor: "gray.400",
          boxShadow: "none !important"
        }
      }
    },
    element: {
      color: "onSurface.mediumEmphasis"
    },
    addon: {
      border: "1px solid",
      borderColor: d("inherit", "whiteAlpha.50")(r),
      bg: d("gray.100", "whiteAlpha.300")(r)
    }
  };
}), S = a((r) => {
  const { theme: e } = r, { focusBorderColor: i, errorBorderColor: n } = f(r);
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: d("gray.100", "whiteAlpha.50")(r),
      _hover: {
        bg: d("gray.200", "whiteAlpha.100")(r)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: o(e, n)
      },
      _focusVisible: {
        bg: "transparent",
        borderColor: o(e, i)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: d("gray.100", "whiteAlpha.50")(r)
    }
  };
}), y = a((r) => {
  const { theme: e } = r, { focusBorderColor: i, errorBorderColor: n } = f(r);
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: o(e, n),
        boxShadow: "0px 1px 0px 0px ".concat(o(e, n))
      },
      _focusVisible: {
        borderColor: o(e, i),
        boxShadow: "0px 1px 0px 0px ".concat(o(e, i))
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent"
    }
  };
}), w = a({
  field: {
    bg: "transparent",
    px: "0",
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: "0",
    height: "auto"
  }
}), z = {
  outline: v,
  filled: S,
  flushed: y,
  unstyled: w
}, $ = m({
  baseStyle: x,
  sizes: C,
  variants: z,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
});
export {
  $ as inputTheme
};
